<template>
  <div class="bg-blue-100 text-sm text-indigo-base">
    <div class="mx-5">
      <div
        class="flex flex-col items-baseline justify-between"
        data-testid="home-app-embed"
        :style="{ height: `${TABLEAU_PAGE_HEIGHT}px` }"
      >
        <VizLoader
          :key="selectedEntity.id"
          :src="homeVizSource"
          :filters="filtersObj"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { homeVizSource } from "@/composables/tableau.js";
import VizLoader from "@/components/VizLoader/index.vue";
import { useStore } from "vuex";
import { TABLEAU_PAGE_HEIGHT } from "@/constants.js";

defineOptions({
  name: "HomeApp",
});

const store = useStore();
const selectedEntity = computed(() => {
  return store.getters["programManager/getSelectedEntityView"];
});

const filtersObj = computed(() => {
  return [
    {
      name: "ENTITY_ID",
      value: selectedEntity.value.id,
    },
  ];
});
</script>
